import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: object = {
  response: null,
  isSuccess: false,
  loading: false,
};

export const getLaborValidationToggleReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.GET_LABOR_VALIDATION_TOGGLE_SUCCESS:
      return {
        ...state,
        isSuccess: true,
        response: action.payload?.data,
        loading: false,
      };

    case laborHoursConstant.GET_LABOR_VALIDATION_TOGGLE_FAILURE:
      return {
        ...state,
        isSuccess: false,
        response: action.payload,
        loading: false,
      };

    case laborHoursConstant.GET_LABOR_VALIDATION_TOGGLE_LOADER:
      return { ...state, loading: true };

    case laborHoursConstant.GET_LABOR_VALIDATION_TOGGLE_RESET:
      return intitialstate;

    default:
      return state;
  }
};
